import React, { useState, useEffect } from "react";
import {
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  toast,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBIcon,
} from "mdbreact";
/* import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon
  ,MDBModal,MDBModalBody , MDBModalHeader, MDBModalFooter } from 'mdbreact'; */

import Axios from "axios";

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import WarningBox from "../components/WarningBox";
import InfoBox from "../components/InfoBox";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { set } from "date-fns";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Customer from "../Customer/Customer";
import AddEditCustomer from "../Customer/AddEditCustomer";
import AddEditItem from "../Administrator/AddEditItem";
import Items from "../Administrator/Items";

const AddEditReceiving = (props) => {
  const useMountEffect = (functionName) => useEffect(functionName, []);
  const serverURL = props.apiServer;
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };

  const [modalCustomerQuickAddOption, showCustomerQuickAddOption] =
    useState(false);
  const toggleCustomerQuickAddOption = () => {
    loadItems();
    showCustomerQuickAddOption(!modalCustomerQuickAddOption);
  };
  const [modalCustomerOption, showCustomerOption] = useState(false);
  const toggleCustomerOption = () => {
    loadItems();
    showCustomerOption(!modalCustomerOption);
  };
  // const [customeroptions, setcustomeroptions] = useState([]);
  // const loadcustomeroption = () => {
  //   Axios.get(serverURL + "/getcustomeroptions", bearer)
  //     .then((res) => {
  //       setcustomeroptions(res.data);
  //     })

  //     .catch((error) => {
  //       setErrorMessage(error);
  //       toggleWarningBox();
  //     });
  // };

  const [frm, setValues] = useState({
    code: props.code,
    itemcode: { value: "", label: "" },
    quantity: 1,
    acquisitioncost: 0,
    datereceived: new Date(),
    username: sessionStorage.getItem("msal.uc"),
    supplier: { value: "", label: "" },
    sellingprice: 0,
    ponumber: "",
    wholesaleprice: 0,
    pototalprice: 0,
    shippingfee: 0,
    markuprate: 0,
    markupamount: 0,
    usemarkuprate: true,
    basesellingprice: 0,
    paymentterms: { value: "1", label: "60 DAYS" },
  });

  const [unitofmeasure, setUnitOfMeasure] = useState("");

  const [tmpSellingPrice, setTmpSellingPrice] = useState(0);
  const [tmpBaseSellingPrice, setTmpBaseSellingPrice] = useState(0);
  const [tmpMarkUpAmount, setTmpMarkUpAmount] = useState(0);
  const [tmpBasePrice, setBasePrice] = useState(0);
  const [tmpTotalPOPrice, setTotalPOPrice] = useState(0);
  const computedSellingPrice = (
    baseprice,
    markuprate,
    markupamount,
    markupbypercentage,
    shippingfee
  ) => {
    let fBasePrice = baseprice.valueOf();
    let fMarkupRate = markuprate.valueOf() / 100;
    let fMarkupAmount = fBasePrice * fMarkupRate;
    let fMarkupAmountFix = markuprate.valueOf();
    let fShippingFee = shippingfee.valueOf();
    let fSellingPrice = 0;
    let fRounded = 0;
    let fRemainder = 0;
    let fAddOn = 0;
    let fBaseSellingPrice = 0;

    if (markupbypercentage === true) {
      fSellingPrice =
        (Number(fBasePrice) + Number(fMarkupAmount)).valueOf() +
        Number(fShippingFee);

      fBaseSellingPrice = fSellingPrice;
      setTmpBaseSellingPrice(fBaseSellingPrice);
      setTmpMarkUpAmount(Number(fMarkupAmount));
      fRemainder = fSellingPrice % 10;

      if (Number(fRemainder) <= 0) {
        fAddOn = 0;
      } else {
        fAddOn = 10 - Number(fRemainder);
      }

      fRounded = fSellingPrice + fAddOn;

      setTmpSellingPrice(fRounded);
      console.log("base price: " + baseprice);
      console.log("markup amount: " + fMarkupAmount);
      console.log("shipping fee: " + fShippingFee);
      console.log("base selling price: " + fBaseSellingPrice);
      console.log("selling price: " + fRounded);
      console.log("remainder: " + fRemainder);
      console.log("add-on: " + fAddOn);

      console.log("markup by rate price:" + fSellingPrice);
    } else {
      fSellingPrice =
        (Number(fBasePrice) + Number(fMarkupAmountFix)).valueOf() +
        Number(fShippingFee);
      // fRounded = Math.ceil((fSellingPrice + 1) / 10) * 10;
      fBaseSellingPrice = fSellingPrice;
      setTmpBaseSellingPrice(fBaseSellingPrice);
      setTmpMarkUpAmount(Number(fMarkupAmountFix));
      fRemainder = fSellingPrice % 10;

      if (Number(fRemainder) <= 0) {
        fAddOn = 0;
      } else {
        fAddOn = 10 - Number(fRemainder);
      }

      fRounded = fSellingPrice + fAddOn;
      // setTmpSellingPrice(fSellingPrice);
      setTmpSellingPrice(fRounded);
      console.log("base price: " + baseprice);
      console.log("markup amount: " + fMarkupAmountFix);
      console.log("shipping fee: " + fShippingFee);
      console.log("base selling price: " + fBaseSellingPrice);
      console.log("selling price: " + fRounded);
      console.log("remainder: " + fRemainder);
      console.log("add-on: " + fAddOn);
      console.log("markup by amount:" + fSellingPrice);
    }
  };
  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;
      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
    }
  };

  const handleChange = (objName) => (selOption) => {
    setValues({ ...frm, [objName]: selOption });

    if (objName === "itemcode") {
      var str = selOption["label"];
      var sStart = str.lastIndexOf("<") + 1;
      var sEnd = str.lastIndexOf(">");
      var tmpunitofmeasure = str.substring(sStart, sEnd);
      console.log(tmpunitofmeasure);
      setUnitOfMeasure(tmpunitofmeasure.toUpperCase());
    }
  };

  const getDateValue = (dtPickerName) => (actualValue) => {
    setValues({ ...frm, [dtPickerName]: actualValue });
  };

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    savereceiving();
  }

  const [errorMessage, setErrorMessage] = useState("");

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const [modalInfo, showInfoBox] = useState(false);

  const toggleInfoBox = () => {
    showInfoBox(!modalInfo);
  };

  const [supplieroptions, setsupplieroptions] = useState([]);
  const loadSuppliers = () => {
    Axios.get(serverURL + "/getsuppliers", bearer)
      .then((res) => {
        setsupplieroptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const [itemoptions, setitemoptions] = useState([]);
  const loadItems = () => {
    Axios.get(serverURL + "/getitems", bearer)
      .then((res) => {
        setitemoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };
  const [paymenttermsoptions, setpaymenttermsoptions] = useState([]);
  const loadpaymentterms = () => {
    Axios.get(serverURL + "/getpaymentterms", bearer)
      .then((res) => {
        setpaymenttermsoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const ClearFields = () => {
    setValues({
      ...frm,
      code: props.code,
      itemcode: { value: "", label: "" },
      quantity: 1,
      acquisitioncost: 0,
      datereceived: new Date(),
      supplier: { value: "", label: "" },
      sellingprice: 0,
      ponumber: "",
      wholesaleprice: 0,
      paymentterms: { value: "1", label: "60 DAYS" },
    });
  };

  const loadReceiving = () => {
    if (props.code === "new") {
      ClearFields();
      return;
    }

    Axios.get(serverURL + "/loadreceiving?code=" + props.code, bearer)
      .then((res) => {
        if (res.data !== "empty") {
          setValues({
            ...frm,
            code: props.code,
            itemcode: { value: res.data.itemcode, label: res.data.description },
            quantity: res.data.quantity,
            acquisitioncost: res.data.acquisitioncost,
            datereceived: new Date(res.data.datereceived),
            supplier: {
              value: res.data.suppliercode,
              label: res.data.supplier,
            },
            sellingprice: res.data.sellingprice,
            ponumber: res.data.ponumber,
            wholesaleprice: res.data.wholesaleprice,
            pototalprice: res.data.pototalprice,
            shippingfee: res.data.shippingfee,
            markuprate: res.data.markuprate,
            markupamount: res.data.markupamount,
            usemarkuprate: res.data.usemarkuprate,
            paymentterms: {
              value: res.data.paymenttermscode,
              label: res.data.paymentterms,
            },
          });

          setUnitOfMeasure(res.data.package);
        } else {
          ClearFields();
        }
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const savereceiving = () => {
    const data = frm;

    Axios.post(props.apiServer + "/savereceiving", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          setValues({ ...frm, code: res.data.code });

          // notify(res.data.message);
          //  toast.info(res.data.message, {
          //     closeButton: false

          //   });
          //  props.showResult(res.data.message);
          props.refreshGrid(res.data.message);
        } else {
          // toast.warning(res.data.message, {
          //     closeButton: false

          //   });

          setErrorMessage(res.data.message);
          toggleWarningBox();
          //  console.log(res.data.message);
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const [modalDelete, showDeleteBox] = useState(false);

  const deleteRecord = () => {
    if (props.code === "new") {
      setErrorMessage("Please select a record!");
      toggleWarningBox();

      return;
    }

    showDeleteBox(!modalDelete);
  };

  function confirmDelete() {
    removereceiving();

    showDeleteBox(!modalDelete);
  }

  const removereceiving = () => {
    const data = frm;

    Axios.post(props.apiServer + "/removereceiving", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          props.refreshGrid(res.data.message);
        } else {
          setErrorMessage(res.data.message);
          //  toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        //  toggleWarningBox();
      });

    //  props.refreshGrid(res.data.message);
  };

  useMountEffect(loadSuppliers);
  useMountEffect(loadItems);
  useMountEffect(loadpaymentterms);
  useMountEffect(checkAdminAccess);
  /* eslint-disable */

  useEffect(() => {
    loadReceiving();
  }, [props.code]);

  useEffect(() => {
    setValues({
      ...frm,
      ["pototalprice"]: frm.acquisitioncost.valueOf() * frm.quantity,
    });
  }, [frm.acquisitioncost, frm.quantity]);

  useEffect(() => {
    setValues({ ...frm, ["sellingprice"]: tmpSellingPrice });
  }, [tmpSellingPrice]);

  useEffect(() => {
    setBasePrice(frm.acquisitioncost);
    computedSellingPrice(
      frm.acquisitioncost,
      frm.markuprate,
      frm.markuprate,
      frm.usemarkuprate,
      frm.shippingfee
    );
    console.log("useeffect baseprice: " + frm.acquisitioncost);
  }, [
    frm.acquisitioncost,
    frm.markuprate,
    frm.markupamount,
    frm.usemarkuprate,
    frm.shippingfee,
    frm.usemarkuprate,
  ]);
  // useEffect(() => {
  //   setBasePrice(frm.acquisitioncost);
  //   computedSellingPrice(
  //     frm.acquisitioncost,
  //     frm.markuprate,
  //     frm.markupamount,
  //     frm.usemarkuprate,
  //     frm.shippingfee
  //   );
  //   console.log("useeffect baseprice: " + frm.acquisitioncost);
  // }, [
  //   frm.acquisitioncost,
  //   frm.markuprate,
  //   frm.markupamount,
  //   frm.usemarkuprate,
  //   frm.shippingfee,
  // ]);
  // useMountEffect(loadReceiving);

  return (
    <React.Fragment>
      <MDBRow className="mb-3">
        <MDBCol md="12">
          <span className="font-weight-bold blue-grey-text">
            Purchase Order Details
          </span>
        </MDBCol>
      </MDBRow>
      <MDBRow className="mt-0 pt-0">
        <MDBCol md="12">
          <form
            className="needs-validation"
            onSubmit={submitHandler}
            noValidate
          >
            <MDBRow hidden>
              <MDBInput value={frm.code} id="code" label="Code">
                <div className="invalid-feedback">This field is required!</div>
                <div className="valid-feedback"></div>
              </MDBInput>
            </MDBRow>
            <MDBRow>
              <MDBCol md="8">
                {" "}
                <label className="grey-text">
                  <small>&nbsp;Supplier</small>
                </label>
                <br />
                <Select
                  placeholderText="Select supplier"
                  isSearchable
                  value={frm.supplier}
                  onChange={handleChange("supplier")}
                  options={supplieroptions}
                  required
                />
                <div className="invalid-feedback">This field is required!</div>
                <div className="valid-feedback"></div>
              </MDBCol>
              <MDBCol md="4">
                <label className="grey-text">
                  <small>&nbsp;Date Received</small>
                </label>
                <br />
                <DatePicker
                  placeholderText="mm/dd/yyyy"
                  selected={frm.datereceived}
                  onChange={getDateValue("datereceived")}
                />
                <br />
                <br />
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol md="6">
                <MDBInput
                  value={frm.ponumber}
                  id="ponumber"
                  label="PO Number"
                  onChange={updateField}
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput>
              </MDBCol>
              <MDBCol md="6">
                <MDBInput
                  value={frm.pototalprice}
                  id="pototalprice"
                  label="PO Total Price"
                  onChange={updateField}
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput>
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol md="8">
                <label className="grey-text">
                  <small>&nbsp;Item / Product</small>
                </label>
                <br />
                <Select
                  placeholderText="Select item/product"
                  isSearchable
                  value={frm.itemcode}
                  onChange={handleChange("itemcode")}
                  options={itemoptions}
                  required
                />

                <div className="invalid-feedback">This field is required!</div>
                <div className="valid-feedback"></div>

                <br />
              </MDBCol>
              <MDBCol md="4" className="ml-0 pr-0 pt-4">
                <MDBBtn
                  size="sm"
                  onClick={toggleCustomerQuickAddOption}
                  className="grey lighten-5 brown-text"
                >
                  <MDBIcon icon="plus" />
                </MDBBtn>
                <MDBBtn
                  size="sm"
                  onClick={toggleCustomerOption}
                  className="grey lighten-5 brown-text"
                >
                  <FontAwesomeIcon icon={faGear} />
                </MDBBtn>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md="8">
                {" "}
                <label className="grey-text">
                  <small>&nbsp;Payment Terms</small>
                </label>
                <br />
                <Select
                  placeholderText="Select item/product"
                  isSearchable
                  value={frm.paymentterms}
                  onChange={handleChange("paymentterms")}
                  options={paymenttermsoptions}
                />
                <br />
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md="6">
                <MDBInput
                  value={frm.quantity}
                  id="quantity"
                  // label={unitofmeasure}
                  label="Quantity Received"
                  required
                  onChange={updateField}
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput>
              </MDBCol>
            </MDBRow>
            <hr />
            <MDBRow>
              <MDBCol md="12">
                <span className="font-weight-bold blue-grey-text">
                  Pricing Per Unit
                </span>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md="6">
                <MDBInput
                  value={frm.acquisitioncost}
                  id="acquisitioncost"
                  label="Acquisition Cost / Base Price (Php)"
                  required
                  onChange={updateField}
                  type="number"
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput>
              </MDBCol>
              <MDBCol md="6">
                <MDBInput
                  value={frm.shippingfee}
                  id="shippingfee"
                  label="Shipping / Delivery Fee (Php)"
                  required
                  onChange={updateField}
                  type="number"
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md="12">
                <MDBInput
                  id="usemarkuprate"
                  label="Markup by Rate (%)"
                  type="checkbox"
                  checked={frm.usemarkuprate}
                  onChange={updateField}
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md="6">
                <MDBInput
                  value={frm.markuprate}
                  id="markuprate"
                  label="Markup Rate (%)"
                  required
                  onChange={updateField}
                  type="number"
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput>
              </MDBCol>
              <MDBCol md="3" className="pt-3">
                {/* <MDBInput
                  value={frm.markupamount}
                  id="markupamount"
                  label="Markup Amount (Php)"
                  required
                  onChange={updateField}
                  type="number"
                  disabled
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput> */}
                <span className="blue-text">
                  Markup Amount:
                  <br />
                </span>
                <span className="green-text black-text">
                  {" "}
                  &nbsp;{tmpMarkUpAmount}
                </span>
              </MDBCol>
              <MDBCol md="3" className="pt-3">
                <span className="green-text">
                  Base Selling Price:
                  <br />
                </span>
                <span className="green-text black-text">
                  {" "}
                  &nbsp;{tmpBaseSellingPrice}
                </span>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md="6">
                <MDBInput
                  value={frm.sellingprice}
                  id="sellingprice"
                  label="Selling Price (Php)"
                  labelClass="font-weight-bold red-text"
                  required
                  onChange={updateField}
                  type="number"
                  className="font-weight-bold"
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput>
              </MDBCol>
              <MDBCol md="6" className="pt-3">
                <MDBBtn className="blue lighten-1" type="submit">
                  Save
                </MDBBtn>
                {props.code === "new" ? (
                  <MDBBtn
                    className="cloudy-knoxville-gradient blue-text"
                    onClick={props.toggleModal}
                  >
                    Close
                  </MDBBtn>
                ) : (
                  ""
                )}

                {isAdmin == 1 && props.code !== "new" ? (
                  <MDBBtn color="danger" onClick={deleteRecord}>
                    Delete
                  </MDBBtn>
                ) : (
                  ""
                )}
              </MDBCol>
              <MDBCol md="6" hidden>
                <MDBInput
                  value={frm.wholesaleprice}
                  id="wholesaleprice"
                  label="Wholesale Price (Php)"
                  required
                  onChange={updateField}
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput>
              </MDBCol>
            </MDBRow>
          </form>
        </MDBCol>
      </MDBRow>

      <MDBModal backdrop={false} isOpen={modalDelete} toggle={deleteRecord}>
        <MDBModalHeader
          className="text-left black-text cloudy-knoxville-gradient"
          titleClass="w-100"
          tag="h5"
        ></MDBModalHeader>
        <MDBModalBody className="text-center">
          <MDBRow>
            <MDBCol size="3" className="text-center">
              <MDBIcon icon="trash-alt" size="5x" className="red-text" />
            </MDBCol>
            <MDBCol size="9" className="black-text text-center">
              <p></p>
              <p>Do you really want to delete this record?</p>
              <p className="text-center">
                <MDBBtn color="danger" onClick={confirmDelete}>
                  Yes
                </MDBBtn>
                <MDBBtn
                  className="cloudy-knoxville-gradient blue-text"
                  onClick={deleteRecord}
                >
                  Cancel
                </MDBBtn>
              </p>
            </MDBCol>
          </MDBRow>
        </MDBModalBody>
      </MDBModal>
      <MDBModal
        backdrop={false}
        isOpen={modalCustomerOption}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBModalHeader
          className="cloudy-knoxville-gradient"
          toggle={toggleCustomerOption}
        >
          <span className="h6-responsive brown-text font-weight-bold">
            Inventory Items Dropdown Management
          </span>
        </MDBModalHeader>
        <MDBModalBody>
          <Items
            deployURL={props.deployURL}
            apiServer={props.apiServer}
            apiServerHybrid={props.apiServerHybrid}
            quicktool={"yes"}
            toggleModal2={toggleCustomerOption}
          />
        </MDBModalBody>
      </MDBModal>
      <MDBModal
        backdrop={false}
        isOpen={modalCustomerQuickAddOption}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBModalHeader
          toggle={toggleCustomerQuickAddOption}
          className="cloudy-knoxville-gradient"
        >
          <span className="h6-responsive brown-text font-weight-bold">
            Add Inventory Item
          </span>
        </MDBModalHeader>
        <MDBModalBody>
          <AddEditItem
            deployURL={props.deployURL}
            apiServer={props.apiServer}
            apiServerHybrid={props.apiServerHybrid}
            quickadd={"yes"}
            toggleModal2={toggleCustomerQuickAddOption}
            itemcode={""}
            toggleModal={props.toggleAddEdit}
            refreshGrid={props.refreshGrid}
          />
        </MDBModalBody>
      </MDBModal>
      <InfoBox
        errorMessage={errorMessage}
        isOpen={modalInfo}
        toggleModal={toggleInfoBox}
      />
      <WarningBox
        errorMessage={errorMessage}
        isOpen={modalWarning}
        toggleModal={toggleWarningBox}
      />
      {/* <MessagePersonalInfo /> */}
    </React.Fragment>
  );
};
export default AddEditReceiving;
